import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=57c471e7&scoped=true&"
import script from "./Priority.vue?vue&type=script&lang=js&"
export * from "./Priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c471e7",
  null
  
)

export default component.exports